import React from 'react';
import './SubcategoryNav.css';

function SubcategoryNav({ subcategories, selectedSubcategory, onSubcategorySelect, responses }) {
  const getSubcategoryProgress = (subcategory) => {
    const answeredCount = subcategory.questions.filter(q => responses[q.id] !== undefined).length;
    return `${answeredCount}/${subcategory.questions.length}`;
  };

  const isSubcategoryComplete = (subcategory) => {
    return subcategory.questions.every(q => responses[q.id] !== undefined);
  };

  return (
    <div className="subcategory-nav">
      <div className="subcategory-scroll-container">
        {subcategories.map((subcategory) => (
          <button
            key={subcategory.id}
            className={`subcategory-item ${selectedSubcategory?.id === subcategory.id ? 'active' : ''} ${isSubcategoryComplete(subcategory) ? 'complete' : ''}`}
            onClick={() => onSubcategorySelect(subcategory)}
          >
            <span className="subcategory-name">{subcategory.name}</span>
            <span className="subcategory-progress">{getSubcategoryProgress(subcategory)}</span>
            {isSubcategoryComplete(subcategory) && (
              <span className="subcategory-check">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SubcategoryNav;
